import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'

import { cashBoxService } from '../../services/cashbox-service'
import {
    HInput,
    HookForm
} from '../../validation/HForm'
import {jewelSchemeFunc} from '../../validation/scheme/wordScheme'
import Loader from './Loader/Loader'

import './jewel-names.scss'

import EditIcon from '../../assets/icons/edit.svg'
import TrashIcon from '../../assets/icons/trash.svg'
import CrossIcon from '../../assets/icons/cross.svg'
import PlusSmallIcon from '../../assets/icons/plus-small.svg'
import LoupeIcon from '../../assets/icons/search.svg'
import { permissionsAccess } from '../../helpers/common';
import {config} from "../../helpers/config";

const JewelNames = () => {
  const [state, setState] = useState({
    loading: false,
    modalCreate: false,
    modalEdit: false,
    names: [],
    name: '',
    entity: null
  })
  useEffect( () => permissionsAccess("action.words.details") && loadWords(), [])

  const changeModalState = (name, state, word) => {
    setState(prev => ({
      ...prev,
      [name]: state,
      entity: word
    }))
  }

  const onWordSubmit = entity => {
    let id
    if (state.entity && state.entity.id) {
      id = state.entity.id
    }
    setState(prev => ({
      ...prev,
      loading: true
    }))
    changeModalState('modalCreate', false)
    changeModalState('modalEdit', false)
    let promise
    if (id) {
      promise = cashBoxService.updateJewel(id, entity.name, entity.synonym, entity.part)
    } else {
      promise = cashBoxService.createJewel(entity.name, entity.synonym, entity.part)
    }
    promise.then(() => {
      loadWords(state.name)
    }).catch(() => {
      setState(prev => ({
        ...prev,
        loading: false
      }))
    })


  }

  const onWordDelete = entity => {
    setState(prev => ({
      ...prev,
      loading: true
    }))
    let id = entity.id
    cashBoxService.deleteWord(id, 'jewel')
      .then(() => {
        loadWords(state.name)
      })
      .catch(() => {
        setState(prev => ({
          ...prev,
          loading: false
        }))
      })
  }

  const handleFilter = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.id

    setState(prev => ({
      ...prev,
      [name]: value
    }))
    loadWords(value)
  }

  const loadWords = name => {
    setState(prev => ({...prev, loading: true}))
    cashBoxService.getJewels(name || '')
      .then((response) => {
        setState(prev => ({
          ...prev,
          names: response.data.jewels
        }))
      }).finally(() => {
      setState(prev => ({...prev, loading: false}))
    })
  }

  return (
    <>
      <div className='content-inner-data-container'>
        <div className='content-datatable'>
          <div className='content-datatable-header'>
            <div className='content-datatable-header-left'>
              <div className='action-items'>
                <div className='content-datatable-header-search '>
                  <div className='datatable-search'>
                    <input
                      className='input-small'
                      type='text'
                      placeholder='Поиск…'
                      name='name'
                      id='name'
                      value={state.name}
                      onChange={handleFilter}
                    />
                    <div className='datatable-search-loupe'>
                      <span className='icon'>
                        <LoupeIcon/>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {
              permissionsAccess("action.words.update") &&
              <div className='content-datatable-header-right'>
                <div className='action-items'>
                  <button
                    className='button-icontrigger caption noborder'
                    onClick={() => changeModalState('modalCreate', true)}
                  >
                  <span className='icon'>
                    <PlusSmallIcon/>
                  </span>
                    <span>Добавить</span>
                  </button>
                </div>
              </div>
            }
          </div>
          <div className='content-datatable-content'>
            <fieldset>
              {
                state.loading ? <Loader/> :
                  <div className='precious-metals-names'>
                    {state.names.map((word) => {
                      const {id, name} = word
                      return (<div key={id} className='name handbook-name'>
                        <div className='checkbox '>
                          <label htmlFor='1'>
                            <span>{name}</span>
                          </label>
                        </div>
                        <div className='name-actions'>
                          {
                            permissionsAccess("action.words.update") &&
                            <button
                              className='button-icontrigger noborder'
                              onClick={() => changeModalState('modalEdit', true, word)}
                            >
                              <span className='icon'>
                                <EditIcon/>
                              </span>
                            </button>
                          }
                          {permissionsAccess("action.words.update") &&
                              <button
                              className='button-icontrigger noborder'
                              onClick={() => onWordDelete(word)}
                          >
                            <span className='icon'>
                              <TrashIcon/>
                            </span>
                          </button>}
                        </div>
                      </div>)
                    })
                    }
                  </div>
              }
            </fieldset>
          </div>
        </div>
      </div>
      <ReactModal
        isOpen={state.modalEdit}
        contentLabel='Modal'
        className='modal-container'
        overlayClassName='modal-overlay'
      >
        <HookForm onSubmit={onWordSubmit}
                  validationSchema={jewelSchemeFunc(config().validatePurities)}
                  defaultValues={state.entity}
                  submitOnEnterPress={true}>
          <div className='modal-header'>
            <h2>Редактировать наименование</h2>
            <button
              className='button-icontrigger modal-closetrigger'
              onClick={() => changeModalState('modalEdit', false)}
            >
              <span className='icon'>
                <CrossIcon/>
              </span>
            </button>
          </div>
          <div className='modal-body'>
            <fieldset>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Название</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='name'
                    id='name'
                    h='true'
                    placeholder=''
                  />
                </div>
              </div>
                {/*    togle????*/}
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Часть</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='part'
                    id='part'
                    h='true'
                    placeholder=''/>
                </div>
              </div>

              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Синоним</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='synonym'
                    id='synonym'
                    h='true'
                    placeholder=''
                  />
                </div>
              </div>
            </fieldset>
          </div>

          <div className='modal-footer'>
            <button className='button'>Сохранить</button>
            <button
              className='button-light'
              type='button'
              onClick={() => changeModalState('modalEdit', false)}
            >
              Отменить
            </button>
          </div>
        </HookForm>
      </ReactModal>
      <ReactModal
        isOpen={state.modalCreate}
        contentLabel='Modal'
        className='modal-container'
        overlayClassName='modal-overlay'
      >
        <HookForm onSubmit={onWordSubmit}
                  validationSchema={jewelSchemeFunc(config().validatePurities)}
                  defaultValues={state.entity}
                  submitOnEnterPress={true}>
          <div className='modal-header'>
            <h2>Добавить наименование</h2>
            <button
              className='button-icontrigger modal-closetrigger'
              onClick={() => changeModalState('modalCreate', false)}
            >
              <span className='icon'>
                <CrossIcon/>
              </span>
            </button>
          </div>
          <div className='modal-body'>
            <fieldset>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Название</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='name'
                    id='name'
                    h='true'
                    placeholder=''/>
                </div>
              </div>
              {/*    togle???????*/}
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Часть</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='part'
                    id='part'
                    h='true'
                    placeholder=''/>
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Синоним</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='synonym'
                    id='synonym'
                    h='true'
                    placeholder=''/>
                </div>
              </div>
            </fieldset>
          </div>
          <div className='modal-footer'>
            <button className='button'>Добавить</button>
            <button
              className='button-light'
              type='button'
              onClick={() => changeModalState('modalCreate', false)}
            >
              Отменить
            </button>
          </div>
        </HookForm>
      </ReactModal>
    </>
  )
}

export default JewelNames
